import React from "react";

var HomeHeartIcon = function HomeHeartIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.2 9.164L12 0 .8 9.164a2.182 2.182 0 0 0-.8 1.688v10.966C0 23.023.977 24 2.182 24h19.636A2.182 2.182 0 0 0 24 21.818V10.852c0-.654-.294-1.274-.8-1.688zm-5.241 4.49c-.483 2.817-2.972 4.808-5.959 6.301-2.987-1.493-5.475-3.484-5.959-6.301-.301-1.757 1.087-3.441 2.859-3.634a3.229 3.229 0 0 1 3.099 1.497 3.23 3.23 0 0 1 3.099-1.497c1.774.193 3.162 1.877 2.861 3.634z"
  }));
};

HomeHeartIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
HomeHeartIcon.defaultProps.solid = true;
export default HomeHeartIcon;